<p class="filter-chips">
  {{ item().view }}
  <mat-icon (click)="item().delete()">close</mat-icon>
</p>
